export default __webpack_public_path__ + "static/media/img1.7e2a4ec0.png";